// src/app/core/services/base-api.service.ts
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { User } from '@app/services/user/user';

export interface HttpOptions {
  headers?: HttpHeaders | { [header: string]: string | string[] };
  observe?: 'body';
  params?: any;
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CustomHttpClient {
  private readonly baseUrl = environment.apiUrl.endsWith('/')
    ? environment.apiUrl
    : `${environment.apiUrl}/`;
  private readonly http = inject(HttpClient);

  private readonly UserService = inject(User);

  /**
   * Normaliza el endpoint removiendo '/' inicial si existe
   */
  private normalizeEndpoint(endpoint: string): string {
    return endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
  }

  /**
   * Construye la URL completa
   */
  private buildUrl(endpoint: string): string {
    return `${
      /http/.test(endpoint) ? '' : this.baseUrl
    }${this.normalizeEndpoint(endpoint)}`;
  }

  private buildOptions(options?: HttpOptions): HttpOptions {
    const token = this.UserService.getCookie('access_token');
    console.log({ token });
    if (token) {
      return options
        ? {
            ...options,
            headers: {
              authorization: `Bearer ${token}`,
            },
          }
        : {
            headers: {
              authorization: `Bearer ${token}`,
            },
          };
    }
    return options || {};
  }

  public get<T>(endpoint: string, options?: HttpOptions): Observable<T> {
    console.log('options', this.buildOptions(options));
    return this.http.get<T>(
      this.buildUrl(endpoint),
      this.buildOptions(options),
    );
  }

  public post<T>(
    endpoint: string,
    body: any,
    options?: HttpOptions,
  ): Observable<T> {
    return this.http.post<T>(
      this.buildUrl(endpoint),
      body,
      this.buildOptions(options),
    );
  }

  public put<T>(
    endpoint: string,
    body: any,
    options?: HttpOptions,
  ): Observable<T> {
    return this.http.put<T>(
      this.buildUrl(endpoint),
      body,
      this.buildOptions(options),
    );
  }

  public patch<T>(
    endpoint: string,
    body: any,
    options?: HttpOptions,
  ): Observable<T> {
    return this.http.patch<T>(
      this.buildUrl(endpoint),
      body,
      this.buildOptions(options),
    );
  }

  public delete<T>(endpoint: string, options?: HttpOptions): Observable<T> {
    return this.http.delete<T>(
      this.buildUrl(endpoint),
      this.buildOptions(options),
    );
  }
}
